/* program groups are the landing pages describing: part-time, full-time, summer etc */

import React from "react";

import Layout from "../components/layout";
import PrimaryMenu from "../components/primaryMenu";
import heroStyles from "../components/css/hero.module.scss";
import SubPageNav from '../sections/subPageNav'
import OffsetContent from "../sections/OffsetContent"
import OfferBox from "../sections/offerBox"
import TitledSection from "../sections/titledSection"
import Faculty from "../sections/faculty"
import "../components/css/global.scss";

/* sections */
export default function({pageContext}) {

  // THIS GETS THE MAIN page data
  let data = pageContext.content.json_data.data; //.content.json_data.data
  console.log(data)
  // THIS GETS THE flyoutmenu navigation
  let navigation = pageContext.flyoutnav;

  // THIS GETS THE SUB NAVIGATION
  const subnavName = data.navigation;

  /****** THIS ONE IS CUSTOMED PER PAGE  *****/
  // THIS GETS THE  SUBLINKS FROM THE PAGE JSON
  let staff = data.staff;

  function search(nameKey, myArray){
    for (var i=0; i < myArray.length; i++) {
        if (myArray[i].name === nameKey) {
            return myArray[i];
        }
    }
  }

  let subnav = search(subnavName, navigation).json_data.data.content.subLinks

return (
    <Layout bHideSignup="true">
      <div className={heroStyles.heroNoSlide} style={{backgroundImage: "url(http://api.vanarts.com/assets/"+data.content.masthead+")"}}>
        <PrimaryMenu navigation={navigation} />
      </div>

      <SubPageNav title={data.content.title} linksData={subnav} linkLabel={data.content.linklabel} type="subpage"/>

      <OffsetContent title={data.message.title} coverImage={data.message.boxImage} >
        <div dangerouslySetInnerHTML={{__html: data.message.content}}></div> 
      </OffsetContent>

      <TitledSection title="Department Heads" theme="ribbon">
          <Faculty id="facultyslider" team={staff}/>
      </TitledSection>
    
      { 
      data.callout && 
        <OfferBox 
        highlight={data.callout.title} 
        cta={data.callout.ctaText} 
        link={data.callout.ctaURL} 
        coverImage={data.callout.boxImage}>
          <div dangerouslySetInnerHTML={{__html: data.callout.content}}></div> 
        </OfferBox>
  
      }

    </Layout>
  );
}
